import { render, staticRenderFns } from "./sendcommandlist.vue?vue&type=template&id=e3179e84&"
import script from "./sendcommandlist.vue?vue&type=script&lang=ts&"
export * from "./sendcommandlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sendcommandlist.vue"
export default component.exports